"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = exports.InfoPanel = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Item = _styledComponents["default"].a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: #fff;\n    padding: 0.8rem;\n    margin-bottom: 0.5rem;\n    color: #333;\n\n    &:hover {\n        text-decoration: none;\n        color: ", ";\n    }\n"])), function (props) {
  return props.theme.admin.colors.brand;
});

exports.Item = Item;

var InfoPanel = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    background-color: #fff;\n    padding: 0.8rem;\n    margin-bottom: 0.8rem;\n\n    p {\n        margin-bottom: 0.5rem;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n    }\n\n    hr {\n        margin-top: 0.8rem;\n        margin-bottom: 0.8rem;\n    }\n"])));

exports.InfoPanel = InfoPanel;
Item.defaultProps = {
  theme: {
    colors: {
      brand: '#338ce4'
    }
  }
};